/* © 2021 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, Oct 6, 2021
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";
import {
	View,
	StyleSheet,
	Clipboard,
	TextInput,
} from "react-native";

import Style from "@aetonix/styles";

import InputContainer from "../Inputs/Layout/InputContainer";
import StyledIconButton from "ae-base/Base/StyledIconButton";
import InputLabel from "ae-forms/src/Inputs/Layout/InputLabel";

import { useResources } from "@aetonix/hooks";

const BORDER_WIDTH = 1.9;

const styles = StyleSheet.create({
	copyButtonContainer: {
		flex: 1,
		justifyContent: "center",
	},
	copyableContainer: {
		borderColor: Style.colors.tertiary,
		borderRadius: 5,
		borderWidth: BORDER_WIDTH,
		display: "flex",
		flexDirection: "row",
		flexWrap: "nowrap",
		justifyContent: "flex-start",
	},
	rightSection: {
		borderColor: Style.colors.tertiary,
		borderLeftWidth: BORDER_WIDTH,
	},
	textInputContainer: {
		alignSelf: "center",
		flex: 1,
		paddingLeft: 10,
		width: 400,
	},
});

export default function OutputCopyableText(props) {
	const { localize } = useResources();
	let text = props.data;
	if (typeof text !== "string")
		text = null;

	const additionalSectionStyles = {
		backgroundColor: props.contrast ? Style.colors.medium : Style.colors.itemLight,
	};

	let textColorStyles = props.contrast ? {color: "white"} : {color: "black"};

	// The prop on web is lowercase and the prop on react native is camelcase
	let isReactNative = true;
	if (typeof navigator != "undefined") {
		isReactNative = false;
	}

	let disabledInputStyles =
		isReactNative ?
			{
				disabledInputStyle: { opacity: 1, ...textColorStyles } // prevents web from greying out text
			} : {
				disabledinputstyle: { opacity: 1, ...textColorStyles } // prevents Android from greying out text
			};

	return (
		<InputContainer style={props.style}>
			<InputLabel ignoreObjectStyle schema={props.schema} title={props.title} contrast={props.contrast} />
			<View style={styles.copyableContainer}>
				<View style={styles.textInputContainer}>
					<TextInput
						value={text || null}
						readOnly
						accessibilityLabel="Copyable input"
						accessibilityRole="none"
						spellCheck={false}
						style={textColorStyles}
						placeholder={!text ? localize("formoutputcopyable.nothingtocopy") : null}
						selectTextOnFocus
						{...disabledInputStyles}
					/>
				</View>
				<View style={[styles.rightSection, additionalSectionStyles]}>
					<View style={styles.copyButtonContainer}>
						<StyledIconButton
							icon={"copy"}
							onPress={() => copyTextToClipboard(text, isReactNative)}
							color={"contrast"}
							disabled={!text}
							standard
						/>
					</View>
				</View>
			</View>
		</InputContainer>
	);
}

async function copyTextToClipboard(text, isReactNative) {
	isReactNative ?
		Clipboard.setString(text) :
		await navigator.clipboard.writeText(text);
}